import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--chat-background);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 93%;
  padding: 0 1rem;
  color: var(--white);
  overflow-y: auto;

  .icon {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 7%;
    width: 4rem;
    position: fixed;
    top: 1.4rem;
    left: 1.4rem;
    width: 2rem;
    height: auto;
    cursor: pointer;
    z-index: 9999;
    transition: transform 0.08s ease, opacity 0.12s ease;
  }
  .IconBack{
    position: fixed;
    top: 0;
    left: 1rem;
    width: 2rem;
    height: 7%;
    cursor: pointer;
    z-index: 9999;
    transition: transform 0.08s ease, opacity 0.12s ease;
  }
  .IconBack:active { transform: scale(0.92); }
  .IconBack:hover { opacity: 0.85; }


  .LogoDell {
    width: 200px;
    margin-top: 2rem;
  }

  .Comments {
    text-align: center;
    margin-top: 1rem;
    font-size: 1.2rem;
    line-height: 1.6;
  }

  .Version {
    margin-top: 1rem;
    font-size: 1.1rem;
  }

  .TableHeader {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-top: 2rem;
    font-size: 1.1rem;
    padding-bottom: 0.5rem;


    p {
      margin: 0;
      text-align: justify;
    }
  }

  .TableBody {
    display: flex;
    flex-direction: column;
    width: 100%;
    

    .Row {
      display: flex;
      justify-content: center;
      padding: 0.3rem 0;

      p {
        font-size: 1em;
        width: 50%;
        text-align: center;
      }
    }
  .Row.GroupedFirstTwo {
    margin-bottom: 0;
  }

  .Row.SecondOfGroup {
    margin-bottom: 3rem; 
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }


 @media (max-width: 768px) {
    padding: 2rem;

    .TableHeader {
      justify-content: space-between;
      width: 100%;
      padding: 0.3rem 0;
      box-sizing: border-box;

      p {
        width: 50%;
        margin-left: auto;
        padding: 0;
        text-align: center;
        text-justify: center;
      }
    }

    .TableBody {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin: 0;
      padding: 0;
      box-sizing: border-box;

      .Row {
        display: flex;
        justify-content: space-between;
        padding: 0.5rem 0;
        width: 100%;
        box-sizing: border-box;

        p {
          font-size: 0.8em;
          width: 100%;
          margin: 0;
          padding: 0;
          text-align: center;
          
        }
      }
    }
  }
`;